import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ResourceList } from '@pos-app/data';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { EventService } from '@pos-app/core-ui';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { getformatedTime, getformatedTimeHHMM, getformatedTimeHHMMForApi } from '../scheduler-helper';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';

@Component({
  selector: 'app-schedulerSetHours',
  styleUrls: ['./schedulerSetHours.component.css'],
  templateUrl: './schedulerSetHours.component.html',
})
export class SchedulerSetHours implements OnInit {
  schedulerSetHoursForm: FormGroup;
  @Input() globalData;
  @Input() formData: FormGroup;
  @Output() onFormGroupChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  showHoursForm: boolean = false;
  overriddenHoursTF: boolean = false;
  overriddenHoursfinishTimeTF: boolean = false;
  overriddenBreakTF: boolean = false;
  disableBreak1: boolean = false;
  disableBreak2: boolean = false;
  disableBreak3: boolean = false;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private eventService: EventService, private toastr: ToastrService) {}

  ngOnInit() {
    let fromTime = [];
    let toTime = [];
    let break1StartTime = [];
    let break2StartTime = [];
    let break3StartTime = [];
    this.schedulerSetHoursForm = new FormGroup({
      hours: new FormControl('', Validators.required),
      startTime: new FormControl(''),
      finishTime: new FormControl(''),
      break1StartTime: new FormControl(''),
      break1EndTime: new FormControl(''),
      break1Name: new FormControl(''),
      break2StartTime: new FormControl(''),
      break2EndTime: new FormControl(''),
      break2Name: new FormControl(''),
      break3StartTime: new FormControl(''),
      break3EndTime: new FormControl(''),
      break3Name: new FormControl(''),
    });
    this.addGroupToParent();

    this.schedulerSetHoursForm.get('hours').valueChanges.subscribe(() => {
      const val = this.schedulerSetHoursForm.getRawValue();
      if (val.hours === 1) {
        this.schedulerSetHoursForm.get('startTime').setValidators(null);
        this.schedulerSetHoursForm.get('finishTime').setValidators(null);
        this.schedulerSetHoursForm.get('startTime').updateValueAndValidity();
        this.schedulerSetHoursForm.get('finishTime').updateValueAndValidity();
        this.showHoursForm = true;
        this.overriddenHoursTF = false;
        this.patchInitialValue();
      }
      if (val.hours === 2) {
        this.schedulerSetHoursForm.get('startTime').setValidators(Validators.required);
        this.schedulerSetHoursForm.get('finishTime').setValidators(Validators.required);
        this.schedulerSetHoursForm.get('startTime').updateValueAndValidity();
        this.schedulerSetHoursForm.get('finishTime').updateValueAndValidity();
        this.showHoursForm = true;
        this.overriddenHoursTF = true;
        this.patchInitialValue();
      }
    });
    this.schedulerSetHoursForm.get('startTime').valueChanges.subscribe(() => {
      //
      const val = this.schedulerSetHoursForm.getRawValue();
      if (val?.startTime) {
        this.overriddenHoursfinishTimeTF = true;
      }
      if (val?.startTime && val?.finishTime) {
        fromTime = val?.startTime.split(':');
        toTime = val?.finishTime.split(':');
        if (
          parseInt(fromTime[0]) > parseInt(toTime[0]) ||
          (parseInt(fromTime[0]) === parseInt(toTime[0]) && parseInt(fromTime[1]) > parseInt(toTime[1]))
        ) {
          this.toastr.error('Start time cannot be after Finish time');
          this.schedulerSetHoursForm.patchValue({
            startTime: '',
          });
        } else if (val?.break1StartTime || val?.break2StartTime || val?.break3StartTime) {
          break1StartTime = val?.break1StartTime && val?.break1StartTime?.split(':');
          break2StartTime = val?.break2StartTime && val?.break2StartTime?.split(':');
          break3StartTime = val?.break3StartTime && val?.break3StartTime?.split(':');
          if (fromTime[0] > break1StartTime[0] || fromTime[0] > break2StartTime[0] || fromTime[0] > break3StartTime[0]) {
            this.toastr.error('Start time cannot be smaller than break start time');
            this.schedulerSetHoursForm.patchValue({
              startTime: '',
            });
          }
          if (
            (parseInt(fromTime[0]) === parseInt(break1StartTime[0]) && parseInt(fromTime[1]) > parseInt(break1StartTime[1])) ||
            (parseInt(fromTime[0]) === parseInt(break2StartTime[0]) && parseInt(fromTime[1]) > parseInt(break2StartTime[1])) ||
            (parseInt(fromTime[0]) === parseInt(break3StartTime[0]) && parseInt(fromTime[1]) > parseInt(break3StartTime[1]))
          ) {
            this.toastr.error('Start time cannot be smaller than current break start time');
            this.schedulerSetHoursForm.patchValue({
              startTime: '',
            });
          }
        }
      }
    });
    this.schedulerSetHoursForm.get('finishTime').valueChanges.subscribe(() => {
      const val = this.schedulerSetHoursForm.getRawValue();
      if (val?.startTime && val?.finishTime) {
        fromTime = val?.startTime.split(':');
        toTime = val?.finishTime.split(':');
        if (
          parseInt(fromTime[0]) > parseInt(toTime[0]) ||
          (parseInt(fromTime[0]) === parseInt(toTime[0]) && parseInt(fromTime[1]) > parseInt(toTime[1]))
        ) {
          this.toastr.error('Finish time cannot be before Start time');
          this.schedulerSetHoursForm.patchValue({
            finishTime: '',
          });
          this.overriddenBreakTF = false;
        } else if (val?.break1EndTime || val?.break2EndTime || val?.break3EndTime) {
          let break1EndTime = val?.break1EndTime && val?.break1EndTime?.split(':');
          let break2EndTime = val?.break2EndTime && val?.break2EndTime?.split(':');
          let break3EndTime = val?.break3EndTime && val?.break3EndTime?.split(':');
          if (toTime[0] < break1EndTime[0] || toTime[0] < break2EndTime[0] || toTime[0] < break3EndTime[0]) {
            this.toastr.error('End time cannot be smaller than  current break end time');
            this.schedulerSetHoursForm.patchValue({
              finishTime: '',
            });
            this.overriddenBreakTF = false;
          }
          if (
            (parseInt(toTime[0]) === parseInt(break1EndTime[0]) && parseInt(toTime[1]) < parseInt(break1EndTime[1])) ||
            (parseInt(toTime[0]) === parseInt(break2EndTime[0]) && parseInt(toTime[1]) < parseInt(break2EndTime[1])) ||
            (parseInt(toTime[0]) === parseInt(break3EndTime[0]) && parseInt(toTime[1]) < parseInt(break3EndTime[1]))
          ) {
            this.toastr.error('Start time cannot be smaller than  current break start time');
            this.schedulerSetHoursForm.patchValue({
              finishTime: '',
            });
            this.overriddenBreakTF = false;
          }
        } else {
          this.overriddenBreakTF = true;
        }
      }
    });

    this.schedulerSetHoursForm.get('break1StartTime').valueChanges.subscribe(() => {
      const val = this.schedulerSetHoursForm.getRawValue();

      const error = val?.break1StartTime && this.breakStartValidation(val?.break1StartTime, fromTime, toTime, val, 1);
      if (error) {
        this.toastr.error(error);
        this.schedulerSetHoursForm.patchValue({
          break1StartTime: '',
        });
        this.schedulerSetHoursForm.get('break1StartTime').setValidators(Validators.required);
        this.schedulerSetHoursForm.get('break1StartTime').updateValueAndValidity();
      } else if (val?.break1StartTime && !val?.break1EndTime) {
        this.schedulerSetHoursForm.get('break1EndTime').setValidators(Validators.required);
        this.schedulerSetHoursForm.get('break1EndTime').updateValueAndValidity();
      }
    });
    this.schedulerSetHoursForm.get('break1EndTime').valueChanges.subscribe(() => {
      const val = this.schedulerSetHoursForm.getRawValue();
      const error = val?.break1EndTime && this.breakEndValidation(val?.break1EndTime, val?.break1StartTime, toTime, val, 1);
      if (error) {
        this.toastr.error(error);
        this.schedulerSetHoursForm.patchValue({
          break1EndTime: '',
        });
        this.schedulerSetHoursForm.get('break1EndTime').setValidators(Validators.required);
        this.schedulerSetHoursForm.get('break1EndTime').updateValueAndValidity();
      } else if (val?.break1EndTime && !val?.break1StartTime) {
        this.schedulerSetHoursForm.get('break1StartTime').setValidators(Validators.required);
        this.schedulerSetHoursForm.get('break1StartTime').updateValueAndValidity();
      }
    });
  }

  private addGroupToParent(): void {
    setTimeout(() => {
      this.formData.addControl('schedulerSetHoursForm', this.schedulerSetHoursForm);

    }, 1);

    // this.onFormGroupChange.emit(this.formData);
  }

  patchInitialValue() {
    //patch initial value as globalData
    this.schedulerSetHoursForm.patchValue({
      startTime: getformatedTime(this.globalData?.startTime.toString()),
      finishTime: getformatedTime(this.globalData?.finishTime.toString()),
      break1StartTime: getformatedTime(this.globalData?.break1StartTime.toString()),
      break1EndTime: getformatedTime(this.globalData?.break1EndTime.toString()),
      break1Name: this.globalData?.break1Name,
      break2StartTime: getformatedTime(this.globalData?.break2StartTime.toString()),
      break2EndTime: getformatedTime(this.globalData?.break2EndTime.toString()),
      break2Name: this.globalData?.break2Name,
      break3StartTime: getformatedTime(this.globalData?.break3StartTime.toString()),
      break3EndTime: getformatedTime(this.globalData?.break3EndTime.toString()),
      break3Name: this.globalData?.break3Name,
    });
  }

  breakStartValidation(breakStartTimeValue, fromTime, toTime, formValue, position) {
    const current = 'break' + position + 'EndTime';
    const currentStart = 'break' + position + 'StartTime';
    const currentValue = formValue[current].split(':');
    let error = '';
    if (fromTime && toTime && breakStartTimeValue) {
      let breakStartTime = breakStartTimeValue.split(':');
      if (
        parseInt(fromTime[0]) > parseInt(breakStartTime[0]) ||
        (parseInt(fromTime[0]) === parseInt(breakStartTime[0]) && parseInt(fromTime[1]) > parseInt(breakStartTime[1]))
      ) {
        error = 'Break time cannot be before start Ttime';
      } else if (
        parseInt(toTime[0]) < parseInt(breakStartTime[0]) ||
        (parseInt(toTime[0]) === parseInt(breakStartTime[0]) && parseInt(toTime[1]) < parseInt(breakStartTime[1]))
      ) {
        error = 'Break time cannot be after finish fime';
      } else if (this.checkBreakOverlap(breakStartTimeValue, formValue, position)) {
        error = 'Break Ttime overLap';
      } else if (
        (formValue[current] !== '' && parseInt(currentValue[0]) < parseInt(breakStartTime[0])) ||
        (formValue[current] !== '' &&
          parseInt(currentValue[0]) === parseInt(breakStartTime[0]) &&
          parseInt(currentValue[1]) < parseInt(breakStartTime[1]))
      ) {
        error = 'Break Ttime cannot be after break finish time';
      }
      if (formValue[current] === '' || error) {
        if (formValue[current] === '' && formValue[currentStart] === '') {
          this.disableBreak1 = false;
          this.disableBreak2 = false;
          this.disableBreak3 = false;
        } else if (position === 1) {
          this.disableBreak1 = false;
          this.disableBreak2 = true;
          this.disableBreak3 = true;
        } else if (position === 2) {
          this.disableBreak1 = true;
          this.disableBreak2 = false;
          this.disableBreak3 = true;
        } else {
          this.disableBreak1 = true;
          this.disableBreak2 = true;
          this.disableBreak3 = false;
        }
      } else {
        this.disableBreak1 = false;
        this.disableBreak2 = false;
        this.disableBreak3 = false;
      }
      return error;
    }
  }
  breakEndValidation(breakEndTimeValue, fromTime, toTime, formValue, position) {
    const current = 'break' + position + 'StartTime';
    const currentEnd = 'break' + position + 'EndTime';
    let error = '';
    if (fromTime && breakEndTimeValue) {
      let breakEndTime = breakEndTimeValue.split(':');
      fromTime = fromTime.split(':');
      if (
        parseInt(fromTime[0]) > parseInt(breakEndTime[0]) ||
        (parseInt(fromTime[0]) === parseInt(breakEndTime[0]) && parseInt(fromTime[1]) > parseInt(breakEndTime[1]))
      ) {
        error = 'Break 1 End time cannot be before Break 1 Start time';
      } else if (
        parseInt(toTime[0]) < parseInt(breakEndTime[0]) ||
        (parseInt(toTime[0]) === parseInt(breakEndTime[0]) && parseInt(toTime[1]) < parseInt(breakEndTime[1]))
      ) {
        error = 'Break 1 time cannot be after Finish time';
      } else if (this.checkBreakOverlap(breakEndTimeValue, formValue, position)) {
        error = 'Break time overLap';
      }
    }
    if (formValue[current] === '' || error) {
      if (formValue[current] === '' && formValue[currentEnd] === '') {
        this.disableBreak1 = false;
        this.disableBreak2 = false;
        this.disableBreak3 = false;
      } else if (position === 1) {
        this.disableBreak1 = false;
        this.disableBreak2 = true;
        this.disableBreak3 = true;
      } else if (position === 2) {
        this.disableBreak1 = true;
        this.disableBreak2 = false;
        this.disableBreak3 = true;
      } else {
        this.disableBreak1 = true;
        this.disableBreak2 = true;
        this.disableBreak3 = false;
      }
    } else {
      this.disableBreak1 = false;
      this.disableBreak2 = false;
      this.disableBreak3 = false;
    }
    return error;
  }
  clearBreakValue(value) {
    this.disableBreak1 = false;
    this.disableBreak2 = false;
    this.disableBreak3 = false;
    switch (value) {
      case 1:
        this?.schedulerSetHoursForm?.patchValue({
          break1StartTime: '',
          break1EndTime: '',
          break1Name: '',
        });

        this?.schedulerSetHoursForm?.get('break1StartTime').setValidators(null);
        this?.schedulerSetHoursForm?.get('break1StartTime').updateValueAndValidity();
        this?.schedulerSetHoursForm?.get('break1EndTime').setValidators(null);
        this?.schedulerSetHoursForm?.get('break1EndTime').updateValueAndValidity();

        break;
      case 2:
        this?.schedulerSetHoursForm?.patchValue({
          break2StartTime: '',
          break2EndTime: '',
          break2Name: '',
        });

        this?.schedulerSetHoursForm?.get('break2StartTime').setValidators(null);
        this?.schedulerSetHoursForm?.get('break2StartTime').updateValueAndValidity();
        this?.schedulerSetHoursForm?.get('break2EndTime').setValidators(null);
        this?.schedulerSetHoursForm?.get('break2EndTime').updateValueAndValidity();

        break;
      case 3:
        this?.schedulerSetHoursForm?.patchValue({
          break3StartTime: '',
          break3EndTime: '',
          break3Name: '',
        });

        this?.schedulerSetHoursForm?.get('break3StartTime').setValidators(null);
        this?.schedulerSetHoursForm?.get('break3StartTime').updateValueAndValidity();
        this?.schedulerSetHoursForm?.get('break3EndTime').setValidators(null);
        this?.schedulerSetHoursForm?.get('break3EndTime').updateValueAndValidity();

      default:
        return;
    }
  }

  checkBreakOverlap(time, formValue, position) {
    const targetDateTime = new Date(`2000-01-01 ${time}`);
    const break1StartDateTime = new Date(`2000-01-01 ${formValue.break1StartTime}`);
    const break1EndDateTime = new Date(`2000-01-01 ${formValue.break1EndTime}`);
    const break2StartDateTime = new Date(`2000-01-01 ${formValue.break2StartTime}`);
    const break2EndDateTime = new Date(`2000-01-01 ${formValue.break2EndTime}`);
    const break3StartDateTime = new Date(`2000-01-01 ${formValue.break3StartTime}`);
    const break3EndDateTime = new Date(`2000-01-01 ${formValue.break3EndTime}`);
    if (
      (targetDateTime >= break1StartDateTime && targetDateTime <= break1EndDateTime && position !== 1) ||
      (targetDateTime >= break2StartDateTime && targetDateTime <= break2EndDateTime && position !== 2) ||
      (targetDateTime >= break3StartDateTime && targetDateTime <= break3EndDateTime && position !== 3)
    ) {
      return true;
    } else {
      return false;
    }
  }
}
